<div style="background-color: black; padding-top: 130px; padding-bottom: 20px;">
    <div class="container text-center">
        <video src="{{decode(clipId)}}" controls style="width: 100%; text-align: center;"></video>
    </div>
</div>